import React from 'react';
import { FaSchool, FaWindowClose } from 'react-icons/fa';

const TrainingPage = ({setNavLinks}) => {
  return (

    <div className='container-fluid'>  
      
      <div> 
          <div className='close-window-icon' ><FaWindowClose color='#1b2328' onClick={()=>{
            
            setNavLinks({serviceLink: true})
            sessionStorage.setItem("currentSession", JSON.stringify({serviceLink: true}));
            }}/> </div>
          <h1 className='title'><FaSchool color='#1b2328' /> Training School </h1>
            
      </div>

      <div className='training-msg '><h1> Coming Soon. Stay Tuned... </h1></div>
</div>
   

  )
}

export default TrainingPage;